/* tslint:disable */
/* eslint-disable */
/**
 * Strømbestilling API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Status for en sikringsordre
 * @export
 */
export const Sikringsordrestatus = {
    AwaitingSignature: 'AWAITING_SIGNATURE',
    AwaitingEarlierSikring: 'AWAITING_EARLIER_SIKRING',
    AwaitingManualContract: 'AWAITING_MANUAL_CONTRACT',
    AwaitingContract: 'AWAITING_CONTRACT',
    AwaitingSecureVolume: 'AWAITING_SECURE_VOLUME',
    ContractFailed: 'CONTRACT_FAILED',
    Failed: 'FAILED',
    Completed: 'COMPLETED',
    Deleted: 'DELETED',
    PartiallyDeleted: 'PARTIALLY_DELETED'
} as const;
export type Sikringsordrestatus = typeof Sikringsordrestatus[keyof typeof Sikringsordrestatus];


export function instanceOfSikringsordrestatus(value: any): boolean {
    for (const key in Sikringsordrestatus) {
        if (Object.prototype.hasOwnProperty.call(Sikringsordrestatus, key)) {
            if (Sikringsordrestatus[key as keyof typeof Sikringsordrestatus] === value) {
                return true;
            }
        }
    }
    return false;
}

export function SikringsordrestatusFromJSON(json: any): Sikringsordrestatus {
    return SikringsordrestatusFromJSONTyped(json, false);
}

export function SikringsordrestatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): Sikringsordrestatus {
    return json as Sikringsordrestatus;
}

export function SikringsordrestatusToJSON(value?: Sikringsordrestatus | null): any {
    return value as any;
}

export function SikringsordrestatusToJSONTyped(value: any, ignoreDiscriminator: boolean): Sikringsordrestatus {
    return value as Sikringsordrestatus;
}

